import { Field, ObjectType, ID, InputType } from 'type-graphql'
import { InventoryTimeSeries } from '../inventory/InventoryTimeSeries'
import { Product } from './Product'

@ObjectType()
@InputType('ProductsAndInventoryInput')
export class ProductsAndInventory {
  @Field(() => ID)
  _id: string

  @Field(() => Product)
  product: Product

  @Field(() => InventoryTimeSeries)
  inventory: InventoryTimeSeries
}
